module.exports = __webpack_public_path__ + "static/media/Rock,Paper,Sicssors-Mockup.a1d7d5d9.png";